import component from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-form/lni-child-labor-complaint-form.component.vue';
import module from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-form/lni-child-labor-complaint-form.module.js';

export default {
    component,
    module,
};